import { Component, Input } from "angular-ts-decorators";
import { Wizard } from "./wizard";
import template from "./finish.html";

@Component({
  selector: "finishButton",
  require: {
    wizard: "^wizard",
  },
  template,
})
export class FinishButton {
  private wizard: Wizard;

  @Input("@") public label: string;

  $onInit() {}

  click() {
    this.wizard.finishWizard();
  }
}
